export const NAME = "genericFormPage" as const;
